import { render } from "./WithdrawList.vue?vue&type=template&id=5554476e&scoped=true"
import script from "./WithdrawList.vue?vue&type=script&lang=js"
export * from "./WithdrawList.vue?vue&type=script&lang=js"

import "./WithdrawList.vue?vue&type=style&index=0&id=5554476e&scoped=true&lang=scss"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5554476e"]])

export default __exports__